import * as types from "../constants/actionTypes";
import * as Tools from "../helpers/Tools";

export const dashboardInitialState = {

     };


export default function dashboardReducer(state = dashboardInitialState, action) {
    switch (action.type) {
        case types.LOAD_DASHBOARD_START:
            return { ...state, error: false, isFetching: true, todosWaiting: true, isEpicDashboardError: false };
        case types.LOAD_DASHBOARD_SUCCESS:
            //debugger;

            let oData = action.dashBoardData;
            if (oData.Appointments) {
                //debugger;
                const appointmenttime = Tools.toJSDate(oData.Appointments.AppointmentDateTime);
                try {
                    if (appointmenttime) {
                        oData.Appointments.appointmenttimes = Tools.timeformat(appointmenttime);
                        oData.Appointments.appointmentEcheckinDays = Tools.calculateDateInDays(appointmenttime, new Date());
                        oData.Appointments.appointmentDateTime = Tools.formatDate(appointmenttime);
                    }
                }
                catch (E) {
                    //debugger;
                }
            }
            return { ...state, isFetching: action.isWaiting, dashBoardDetails: oData, isEpicDashboardError: false };
        case types.LOAD_DASHBOARD_V2_SUCCESS:
            return { ...state, dashboardV2: action.dashBoardDataV2 };
        case types.LOAD_DASHBOARD_ERROR:
            return { ...state, isEpicDashboardError: true  };
        //case types.AJAX_CALL_ERROR:
        //    debugger;
        //    return { ...state, isFetching: false, error: action.error };
        case types.USER_LOGGED_OUT:
            //debugger;
            return { ...dashboardInitialState, error: action.errorCode };
        default:
            return { ...state };

    }
}